import { useCallback } from "react";
import {
  createManualCall,
  getCallById,
  triggerAICall,
  updateManualStatusByAccount,
  updateCallManualStatus,
} from "../service/CallCenterCalls";
import { useAsyncAction } from "./useAsyncAction";

export const useCallCenterCalls = () => {
  const state = useAsyncAction(null);

  const createManual = useCallback(
    async (payload) => state.run(() => createManualCall(payload)),
    [state]
  );

  const triggerAI = useCallback(
    async (payload) => state.run(() => triggerAICall(payload)),
    [state]
  );

  const fetchById = useCallback(
    async (callId) => state.run(() => getCallById(callId)),
    [state]
  );

  const updateManualStatus = useCallback(
    async (id, payload) => state.run(() => updateCallManualStatus(id, payload)),
    [state]
  );

  const updateManualStatusForAccount = useCallback(
    async (payload) => state.run(() => updateManualStatusByAccount(payload)),
    [state]
  );

  return {
    ...state,
    createManual,
    triggerAI,
    fetchById,
    updateManualStatus,
    updateManualStatusForAccount,
  };
};
